/* ============================================================================
   "¿Este usuario es administrativo?" — una sola definición.

   Este catálogo ya existía DUPLICADO en `Layout/Admin.js` y en
   `Components/Sidebar/Sidebar.js` para decidir quién entra a /configuracion.
   Se centraliza aquí en vez de mantener dos copias.

   NO se usa para la descarga de listados: eso tiene ahora sus propios permisos
   (`pacientes.export` y compañía) en el catálogo del backend.

   NINGÚN permiso es inventado: son los del catálogo real del backend
   (`src/rbac/constants.ts`). Con este conjunto:

     · pasan  -> MASTERADMIN_PLATFORM, SUPERADMIN_PLATFORM, ADMIN_COMPANY,
                 ADMIN_CLINICA y LEGACY_ADMIN
     · NO pasan -> DOCTOR y SIGNOS_VITALES

   `clinics.view` (singular) queda FUERA a propósito: DOCTOR también lo tiene,
   e incluirlo convertiría a cualquier médico en administrativo.

   ========================================================================== */

export const ADMIN_AREA_PERMISSIONS = [
    "company.view",
    "clinics.view_list",
    "users.view_list",
    "roles.view",
    "security.access_log.view",
    "doctors.view",
    "especialidades.view",
    "seguros.view",
    "procedimientosprecios.view",
    "promociones.view",
    "planes.view",
];

/** @param {(nombre: string) => boolean} hasPermission de `usePermissions()` */
export function esAdministrativo(hasPermission) {
    if (typeof hasPermission !== "function") return false;
    return ADMIN_AREA_PERMISSIONS.some((p) => hasPermission(p));
}

export default esAdministrativo;
